<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="frontmatter">
<p class="sp"> </p>
<header>
<h1 class="FMH"><a href="#/xhtml/contents#c_abb">Abbreviations</a></h1>
</header>
<figure class="table">
<table class="Basic-Table" id="table001">
<tbody><tr class="Basic-Table">
<td class="Basic-Table col5">
<p class="ABBL"><i>CA</i></p>
</td>
<td class="Basic-Table col95">
<p class="ABBL">John Paul II, <i>Centesimus Annus</i> (1991)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>CV</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">Benedict XVI, <i>Caritas in Veritate</i> (2009)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>DC</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">Benedict XVI, <i>Deus Caritas Est</i> (2005)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>DM</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">John Paul II, <i>Dives in Misericordia</i> (1980)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>EA</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">John Paul II, <i>Ecclesia in America</i> (1999)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>EG</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">Francis, <i>Evangelii Gaudium</i> (2013)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>LE</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">John Paul II, <i>Laborem Exercens</i> (1981)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>LS</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">Francis, <i>Laudato Si’</i> (2015)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>MM</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">John XXIII, <i>Mater et Magistra</i> (1961)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>PP</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">Paul VI, <i>Populorum Progressio</i> (1967)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>QA</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">Pius XI, <i>Quadragesimo Anno</i> (1931)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>RH</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">John Paul II, <i>Redemptor Hominis</i> (1979)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>RN</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">Leo XIII, <i>Rerum Novarum</i> (1891)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>SRS</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">John Paul II, <i>Sollicitudo Rei Socialis</i> (1987)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>SS</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">Benedict XVI, <i>Spe Salvi</i> (2007)</p>
</td>
</tr>
<tr class="Basic-Table">
<td class="Basic-Table">
<p class="ABBL"><i>VS</i></p>
</td>
<td class="Basic-Table">
<p class="ABBL">John Paul II, <i>Veritatis Splendor</i> (1993)</p>
</td>
</tr>
</tbody></table>
</figure>
<p class="ABBLL">All references to the Bible, unless otherwise noted, are from the <i>New American Bible</i>, the translation used in the worship and prayer of US Catholics, available on the US Conference of Catholic Bishops website at <a href="http://usccb.org/bible/index.cfm" target="_blank">http://usccb.org/bible/index.cfm</a>.</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?5c0a8d9e